<template>
  <div class="container">
    <el-button type="text" @click="markTip">如何标注类别?</el-button>
    <el-dialog
      title="识别框类别标注指南"
      custom-class="dialog"
      :visible.sync="tipDialogShow"
      width="800px">
      <div class="tip-text">
        <ul>
          <li>0. 所有的图框 <b class="danger-text">均默认为碗碟</b>, 所以只需标注 <b class="danger-text">非碗碟类型的图框</b>即可</li>
          <li>1. 点击需要标注的图框</li>
          <li>2. 此时右侧列表框为可选状态, 点击选择要使用的类别, 如果没有要使用的类别就点击 <b class="primary-text">添加新类</b>, 并选择</li>
          <li>3. 一个图框的类别就标注完毕了;</li>
        </ul>
        <ul class="tip danger-text">
          <h4>需要注意的点</h4>
          <li><b>如果面食(或其他类别)在碗碟中, 此时需要把碗碟和面食都设置识别框, 并分别设置类别</b></li>
        </ul>
      </div>
      <img src="https://eatery.oss-cn-hangzhou.aliyuncs.com/tip.png" width="700" alt="">
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'regionMarkTip',
  components: {},
  data () {
    return {
      tipDialogShow: false
    };
  },
  mounted () {

  },
  methods: {
    markTip () {
      this.tipDialogShow = true;
    }
  },
  computed: {},
  watch: {}
};
</script>
<style lang="scss" scoped>
  .container {
    .dialog {
      .el-dialog__body {
        padding: 0!important;
      }
      .danger-text {
      
      }
    }
  }

</style>
